export default __webpack_public_path__ + "static/media/Izumi_Swimsuit.c69e5f0f.png";